import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import logo from '/images/logos/logo-sexagogo-redblack.png'
import { useTranslation } from 'react-i18next'
import { FaFilter, FaSignInAlt, FaSignOutAlt, FaUser } from 'react-icons/fa'
import AbsoluteTopBarFilter from './AbsoluteTopBarFilter'
import { MdOutlineStarOutline } from 'react-icons/md'
import CookieManager from '../lib/CookiesManager'
import { IoMdSettings } from 'react-icons/io'
import LanguageSelector from './LanguageSelector'
import AuthService from '../../services/login'
import { ScreenMode, ScreenModeType } from '../pages/LoginRegisterPages'

const menuItems = [
  { path: '/private', text: 'create-ad.private' },
  { path: '/escort', text: 'create-ad.escort' },
  { path: '/massage', text: 'create-ad.massage-pro' },
  { path: '/libertins', text: 'create-ad.libertines' },
  { path: '/establishment', text: 'create-ad.establishments' },
  { path: '/event', text: 'create-ad.events' },
  { path: '/work', text: 'create-ad.jobs' },
  {
    path: 'https://www.xcams.com/',
    text: 'create-ad.webcam',
    target: '_blank',
  },
  {
    path: 'https://www.pornhub.com/',
    text: 'create-ad.porn',
    target: '_blank',
  },
]

interface NavProps {
  onSwitchMode: (mode: ScreenModeType) => void
}

export default function Nav({ onSwitchMode }: NavProps) {
  const [isFixed, setIsFixed] = useState(false)
  const [isVisible, setIsVisible] = useState(true)
  const [lastScrollY, setLastScrollY] = useState(0)
  const [isFilterVisible, setIsFilterVisible] = useState(false)
  const navigate = useNavigate()
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const { t } = useTranslation()
  const location = useLocation()
  const isLoggedIn = !!CookieManager.getToken()
  const footerMenuItems = [
    { path: '/contact', text: 'contact' },
    { path: '/help/', text: 'help' },
    { path: '/popular/', text: 'popular' },

    { path: '/regions/', text: 'regions' },
  ]

  const isActive = (path: string) => location.pathname === path

  useEffect(() => {
    const controlNavbar = () => {
      const currentScrollY = window.scrollY

      if (currentScrollY > lastScrollY && currentScrollY > 150) {
        setIsVisible(false)
      } else {
        setIsVisible(true)
      }

      setIsFixed(currentScrollY > 0)
      setLastScrollY(currentScrollY)
    }

    window.addEventListener('scroll', controlNavbar)
    return () => window.removeEventListener('scroll', controlNavbar)
  }, [lastScrollY])

  useEffect(() => {
    if (isMenuOpen || isFilterVisible) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'unset'
    }

    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [isMenuOpen, isFilterVisible])

  return (
    <>
      <nav
        className={`
          w-full transition-all duration-200 z-40 mx-auto bg-white shadow-md
          ${isFixed ? 'fixed left-0 right-0 ' : 'relative'}
          ${!isFixed ? 'max-w-7xl xl:rounded-lg xl:-mt-9' : ''}
          ${isFixed && isVisible ? 'top-0' : '-top-full'}
        `}
      >
        <div className='px-4 xl:px-8 py-2 xl:py-4'>
          <div className='flex items-center justify-between'>
            <div className='flex gap-4'>
              <Link to='/'>
                <img
                  src={logo}
                  alt='logo'
                  className={`h-10 xl:h-10 ${
                    isFixed ? 'xl:border-r xl:pr-6 border-redpink' : ''
                  }`}
                />
              </Link>
            </div>

            <div className='flex items-center gap-1 xl:hidden'>
              <button
                onClick={() => setIsFilterVisible(!isFilterVisible)}
                className='p-2 hover:text-redpink transition-colors duration-200'
              >
                <FaFilter className='text-xl text-anthracite' />
              </button>
              <div className='bg-transparent pl-2 pr-1 py-0 rounded-lg'>
                <LanguageSelector />
              </div>

              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className='flex flex-col gap-1.5 p-2'
                aria-label='Menu'
              >
                <span
                  className={`w-6 h-0.5 bg-redpink transition-all transform duration-300 ${
                    isMenuOpen ? 'rotate-45 translate-y-2' : ''
                  }`}
                />
                <span
                  className={`w-6 h-0.5 bg-redpink transition-all duration-300 ${
                    isMenuOpen ? 'opacity-0' : ''
                  }`}
                />
                <span
                  className={`w-6 h-0.5 bg-redpink transition-all transform duration-300 ${
                    isMenuOpen ? '-rotate-45 -translate-y-2' : ''
                  }`}
                />
              </button>
            </div>

            <div className='hidden xl:flex items-center flex-grow ml-8'>
              <ul className='flex flex-wrap justify-between w-full'>
                {menuItems.map(item => (
                  <li key={item.path} className='mx-4 relative group'>
                    <Link
                      to={item.path}
                      target={item.target}
                      className={`px-0 py-2 transition-all ${
                        isActive(item.path)
                          ? 'text-redpink'
                          : 'hover:text-redpink'
                      }`}
                    >
                      {t(item.text)}
                    </Link>
                    <div className='absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-0 h-0.5 bg-redpink transition-all duration-300 group-hover:w-full' />
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {isMenuOpen && (
          <div
            className={`xl:px-8 bg-anthraciteLight w-full shadow-md transform transition-transform  duration-300 ease-in-out fixed inset-y-0 right-0 top-14 xl:top-16 z-20 sm:w-full ${
              isMenuOpen ? 'translate-x-0' : 'translate-x-full'
            }`}
          >
            <div className='overflow-y-auto h-full'>
              <div className='p-4  bg-anthracite text-white'>
                {isLoggedIn ? (
                  <>
                    <div className='grid grid-cols-2 gap-2 '>
                      <Link
                        to='/dashboard/'
                        className='flex items-center justify-center bg-emerald-500 text-white text-sm rounded-md space-x-2'
                        onClick={() => setIsMenuOpen(false)}
                      >
                        <FaUser className='' />
                        <span>{t('my-account')}</span>
                      </Link>
                      <Link
                        to='/dashboard/settings/'
                        className='flex items-center py-1 justify-center bg-blue-500 text-white text-sm rounded-md space-x-2'
                        onClick={() => setIsMenuOpen(false)}
                      >
                        <IoMdSettings className='text-lg' />
                        <span>{t('settings')}</span>
                      </Link>

                      <Link
                        to='/favorites'
                        className='flex items-center justify-center bg-yellow-500 text-white text-sm rounded-md space-x-2'
                        onClick={() => setIsMenuOpen(false)}
                      >
                        <MdOutlineStarOutline className='text-lg' />
                        <span>{t('favorites')}</span>
                      </Link>
                      <button
                        onClick={() => {
                          localStorage.clear()
                          AuthService.logout()
                          setIsMenuOpen(false)
                          navigate('/')
                        }}
                        className='flex items-center py-1 justify-center bg-redpink text-white text-sm rounded-md space-x-2'
                      >
                        <FaSignOutAlt className='text-lg' />
                        <span>{t('disconnect')}</span>
                      </button>
                    </div>
                  </>
                ) : (
                  <div className='grid grid-cols-2 gap-4'>
                    <Link
                      to='/login'
                      className='flex items-center justify-center py-1 bg-emerald-500 text-white text-sm rounded-md space-x-2'
                      onClick={() => {
                        setIsMenuOpen(false)
                        window.history.pushState({}, '', '/login')
                      }}
                    >
                      <FaSignInAlt className='text-sm' />
                      <span>{t('login')}</span>
                    </Link>
                    <Link
                      to='/register'
                      className='flex items-center justify-center py-1 text-white bg-redpink text-sm rounded-md space-x-2'
                      onClick={() => {
                        setIsMenuOpen(false)
                        window.history.pushState({}, '', '/register')
                      }}
                    >
                      <FaUser className='text-sm' />
                      <span>{t('register')}</span>
                    </Link>
                  </div>
                )}
              </div>
              <span className='xl:hidden flex justify-end mr-4 mt-3'></span>
              <div className='grid grid-cols-2 gap-3 px-4 py-3'>
                <div className='space-y-3'>
                  {[...menuItems, ...footerMenuItems]
                    .slice(
                      0,
                      Math.ceil(
                        (menuItems.length + footerMenuItems.length) / 2,
                      ),
                    )
                    .map(item => (
                      <div key={item.path}>
                        <Link
                          to={item.path}
                          className={`block py-1 text-white text-sm transition-colors  rounded-lg text-center duration-200 ${
                            isActive(item.path)
                              ? 'text-redpink font-medium'
                              : 'hover:text-redpink'
                          }`}
                          onClick={() => setIsMenuOpen(false)}
                        >
                          {t(item.text)}
                        </Link>
                      </div>
                    ))}
                </div>

                <div className='space-y-3'>
                  {[...menuItems, ...footerMenuItems]
                    .slice(
                      Math.ceil(
                        (menuItems.length + footerMenuItems.length) / 2,
                      ),
                    )
                    .map(item => (
                      <div key={item.path}>
                        <Link
                          to={item.path}
                          className={`block py-1 text-sm text-white transition-colors rounded-lg text-center duration-200 ${
                            isActive(item.path)
                              ? 'text-redpink font-medium'
                              : 'hover:text-redpink'
                          }`}
                          onClick={() => setIsMenuOpen(false)}
                        >
                          {t(item.text)}
                        </Link>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
        )}
      </nav>

      {isFilterVisible && (
        <>
          <div
            className='fixed inset-0 bg-black/50 z-40 xl:hidden'
            onClick={() => setIsFilterVisible(false)}
          />
          <div className='fixed inset-x-0 top-0 z-50 bg-white xl:hidden  max-h-screen'>
            {' '}
            <div className='flex items-center justify-between px-4 py-2 mb-2 '>
              <h2 className='text-lg font-medium'>{t('filters')}</h2>
              <button
                onClick={() => setIsFilterVisible(false)}
                className='p-2'
                aria-label='Close filters'
              >
                ✕
              </button>
            </div>
            <div className='p-4'>
              {' '}
              <AbsoluteTopBarFilter
                isVisible={isFilterVisible}
                onClose={() => setIsFilterVisible(false)}
              />
            </div>
          </div>
        </>
      )}
    </>
  )
}
